var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSqfttemp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "set-square-measure-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.4166 1.5329C23.0569 1.36898 22.648 1.42818 22.3493 1.68754L0.344241 20.8111C0.0271316 21.0867 -0.0827434 21.519 0.0643972 21.9125C0.211538 22.306 0.578007 22.5603 0.9981 22.5603H23.0032C23.5528 22.5603 24 22.1131 24 21.5634V2.43998C24 2.04449 23.7764 1.69691 23.4166 1.5329ZM23.2018 6.19349H23.2018H21.5308C21.3103 6.19349 21.1317 6.37218 21.1317 6.59259C21.1317 6.81299 21.3103 6.99168 21.5308 6.99168H23.2018V12.6366H21.5308C21.3103 12.6366 21.1317 12.8153 21.1317 13.0357C21.1317 13.2561 21.3103 13.4348 21.5308 13.4348H23.2018V18.932H21.78C21.5595 18.932 21.3809 19.1107 21.3809 19.3311C21.3809 19.5515 21.5595 19.7302 21.78 19.7302H23.2018V21.5635C23.2018 21.673 23.1127 21.7621 23.0032 21.7621H21.3094V20.4441C21.3094 20.2237 21.1307 20.045 20.9103 20.045C20.6898 20.045 20.5112 20.2237 20.5112 20.4441V21.7621H14.8663V20.0911C14.8663 19.8707 14.6877 19.692 14.4672 19.692C14.2468 19.692 14.0681 19.8707 14.0681 20.0911V21.7621H8.42319V20.0911C8.42319 19.8707 8.24455 19.692 8.0241 19.692C7.80365 19.692 7.62501 19.8707 7.62501 20.0911V21.7621H0.9981C0.873741 21.7621 0.826538 21.6719 0.812053 21.633C0.797569 21.5942 0.773897 21.4952 0.867835 21.4135L22.873 2.29002C22.9169 2.25182 22.9618 2.24029 23.0001 2.24029C23.0374 2.24029 23.0683 2.25135 23.0856 2.25918C23.1206 2.27507 23.2018 2.32462 23.2018 2.43993V6.19349Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.6024 10.0071C18.3828 9.90694 18.1334 9.94308 17.9511 10.1014L13.4802 13.9869C13.3138 14.1315 13.2962 14.3836 13.4408 14.5499C13.5854 14.7163 13.8375 14.7339 14.0038 14.5893L18.1601 10.9772V17.0622H11.1581L11.7386 16.5579C11.9049 16.4133 11.9226 16.1612 11.778 15.9948C11.6334 15.8284 11.3813 15.8108 11.215 15.9554L10.2511 16.7931C10.0576 16.9613 9.99052 17.2251 10.0803 17.4651C10.1701 17.7052 10.3937 17.8604 10.6501 17.8604H18.3501C18.6855 17.8604 18.9583 17.5875 18.9583 17.2521V10.5605C18.9583 10.3193 18.8219 10.1071 18.6024 10.0071Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.19206 21.349C3.41248 21.349 3.59116 21.1703 3.59116 20.9499C3.59116 20.7295 3.41248 20.5508 3.19206 20.5508C2.97165 20.5508 2.79297 20.7295 2.79297 20.9499C2.79297 21.1703 2.97165 21.349 3.19206 21.349Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.80144 21.349C5.02185 21.349 5.20053 21.1703 5.20053 20.9499C5.20053 20.7295 5.02185 20.5508 4.80144 20.5508C4.58102 20.5508 4.40234 20.7295 4.40234 20.9499C4.40234 21.1703 4.58102 21.349 4.80144 21.349Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.41277 21.349C6.63318 21.349 6.81186 21.1703 6.81186 20.9499C6.81186 20.7295 6.63318 20.5508 6.41277 20.5508C6.19235 20.5508 6.01367 20.7295 6.01367 20.9499C6.01367 21.1703 6.19235 21.349 6.41277 21.349Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.63542 21.349C9.85583 21.349 10.0345 21.1703 10.0345 20.9499C10.0345 20.7295 9.85583 20.5508 9.63542 20.5508C9.41501 20.5508 9.23633 20.7295 9.23633 20.9499C9.23633 21.1703 9.41501 21.349 9.63542 21.349Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.2468 21.349C11.4672 21.349 11.6458 21.1703 11.6458 20.9499C11.6458 20.7295 11.4672 20.5508 11.2468 20.5508C11.0263 20.5508 10.8477 20.7295 10.8477 20.9499C10.8477 21.1703 11.0263 21.349 11.2468 21.349Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.8561 21.349C13.0765 21.349 13.2552 21.1703 13.2552 20.9499C13.2552 20.7295 13.0765 20.5508 12.8561 20.5508C12.6357 20.5508 12.457 20.7295 12.457 20.9499C12.457 21.1703 12.6357 21.349 12.8561 21.349Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M16.0788 21.349C16.2992 21.349 16.4779 21.1703 16.4779 20.9499C16.4779 20.7295 16.2992 20.5508 16.0788 20.5508C15.8584 20.5508 15.6797 20.7295 15.6797 20.9499C15.6797 21.1703 15.8584 21.349 16.0788 21.349Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M17.6882 21.349C17.9086 21.349 18.0872 21.1703 18.0872 20.9499C18.0872 20.7295 17.9086 20.5508 17.6882 20.5508C17.4677 20.5508 17.2891 20.7295 17.2891 20.9499C17.2891 21.1703 17.4677 21.349 17.6882 21.349Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M19.2995 21.349C19.5199 21.349 19.6986 21.1703 19.6986 20.9499C19.6986 20.7295 19.5199 20.5508 19.2995 20.5508C19.0791 20.5508 18.9004 20.7295 18.9004 20.9499C18.9004 21.1703 19.0791 21.349 19.2995 21.349Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M22.3913 18.2669C22.6117 18.2669 22.7904 18.0883 22.7904 17.8678C22.7904 17.6474 22.6117 17.4688 22.3913 17.4688C22.1709 17.4688 21.9922 17.6474 21.9922 17.8678C21.9922 18.0883 22.1709 18.2669 22.3913 18.2669Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M22.3913 16.6556C22.6117 16.6556 22.7904 16.4769 22.7904 16.2565C22.7904 16.0361 22.6117 15.8574 22.3913 15.8574C22.1709 15.8574 21.9922 16.0361 21.9922 16.2565C21.9922 16.4769 22.1709 16.6556 22.3913 16.6556Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M22.3913 15.0443C22.6117 15.0443 22.7904 14.8656 22.7904 14.6452C22.7904 14.4248 22.6117 14.2461 22.3913 14.2461C22.1709 14.2461 21.9922 14.4248 21.9922 14.6452C21.9922 14.8656 22.1709 15.0443 22.3913 15.0443Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M22.3913 11.8236C22.6117 11.8236 22.7904 11.6449 22.7904 11.4245C22.7904 11.2041 22.6117 11.0254 22.3913 11.0254C22.1709 11.0254 21.9922 11.2041 21.9922 11.4245C21.9922 11.6449 22.1709 11.8236 22.3913 11.8236Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M22.3913 10.2122C22.6117 10.2122 22.7904 10.0336 22.7904 9.81316C22.7904 9.59274 22.6117 9.41406 22.3913 9.41406C22.1709 9.41406 21.9922 9.59274 21.9922 9.81316C21.9922 10.0336 22.1709 10.2122 22.3913 10.2122Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M22.3913 8.60092C22.6117 8.60092 22.7904 8.42224 22.7904 8.20183C22.7904 7.98142 22.6117 7.80273 22.3913 7.80273C22.1709 7.80273 21.9922 7.98142 21.9922 8.20183C21.9922 8.42224 22.1709 8.60092 22.3913 8.60092Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M22.3913 5.38022C22.6117 5.38022 22.7904 5.20154 22.7904 4.98112C22.7904 4.76071 22.6117 4.58203 22.3913 4.58203C22.1709 4.58203 21.9922 4.76071 21.9922 4.98112C21.9922 5.20154 22.1709 5.38022 22.3913 5.38022Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M22.3913 3.76889C22.6117 3.76889 22.7904 3.59021 22.7904 3.3698C22.7904 3.14938 22.6117 2.9707 22.3913 2.9707C22.1709 2.9707 21.9922 3.14938 21.9922 3.3698C21.9922 3.59021 22.1709 3.76889 22.3913 3.76889Z",
    fill: "#A48111"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M12.6042 15.6947C12.8246 15.6947 13.0033 15.516 13.0033 15.2956C13.0033 15.0752 12.8246 14.8965 12.6042 14.8965C12.3838 14.8965 12.2051 15.0752 12.2051 15.2956C12.2051 15.516 12.3838 15.6947 12.6042 15.6947Z",
    fill: "#A48111"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqfttemp);
export default __webpack_public_path__ + "static/media/sqfttemp.9eaf38f75341bc3eb64e355dffc86d67.svg";
export { ForwardRef as ReactComponent };